module.exports = __webpack_public_path__ + "src/assets/games/9/167.jpg";